import { CreateContractContext } from "@/contexts/CreateContractContext"
import { useContext } from "react"

export const useCreateContractContext = () => {
  const context = useContext(CreateContractContext)

  if (!context) throw new Error('useCreateContractContext have to wrapped by useCreateContractContextProvider')

  return context
}
